import { trNormalize, baseType } from "./text";

export function normalizePlanRow(row) {
  return {
    city: trNormalize(row.city),
    unit: baseType(row.unit),
  };
}

export function normalizeDataRow(row) {
  // Excel’lerde değişken isimleri farklı olabiliyor: IL/İl, TUR/Tür, AD/Adres...
  const city = trNormalize(row.IL ?? row["İl"] ?? row.il ?? row.city ?? "");
  const type = baseType(row.TUR ?? row["Tür"] ?? row.tur ?? row.type ?? "");
  return { city, type };
}

/**
 * planRows: [{city, unit, ...}]
 * datasets: [{name, rows: [raw objects]}]
 * return: {matches:[{planRowIndex, plan, items:[raw,...]}], totalMatches}
 */
export function matchPlanWithDatasets(planRows, datasets) {
  const matches = [];
  let totalMatches = 0;

  planRows.forEach((pr, idx) => {
    const p = normalizePlanRow(pr);
    const items = [];
    datasets.forEach((ds) => {
      ds.rows.forEach((r) => {
        const d = normalizeDataRow(r);
        if (!p.city || !p.unit) return;
        if (p.city === d.city && (p.unit === d.type || !d.type)) {
          items.push({ ...r, __dataset: ds.name });
        }
      });
    });
    if (items.length > 0) {
      matches.push({ planRowIndex: idx, plan: pr, items });
      totalMatches += items.length;
    }
  });

  return { matches, totalMatches };
}

// Excel içinden sayısal alanları çıkar
export function numericColumns(rows) {
  if (!rows || rows.length === 0) return [];
  const sample = rows[0];
  return Object.keys(sample).filter((k) => typeof sample[k] === "number");
}
